import React from 'react'

const BlockButton = ({
  onClick,
  disabled = false,
  backgroundColor,
  hoverBackgroundColor,
  textColor,
  className = '',
  icon,
  text
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center justify-center space-x-2 w-full px-6 py-3 rounded-lg ${backgroundColor} hover:${hoverBackgroundColor} ${textColor} transition-colors ${className}`}
    >
      {icon && icon}
      <span>{text}</span>
    </button>
  );
}

export default BlockButton